require("style-loader!css-loader!less-loader!./font-awesome-styles.loader.js!./font-awesome.config.js");



//////////////////
// WEBPACK FOOTER
// ./node_modules/font-awesome-webpack/index.js
// module id = iGtm
// module chunks = 0